import React, { useState } from 'react';
import { Search, Calendar } from 'lucide-react';
import FeeCollectionCharts from './FeeCollectionCharts';
import SecurityFeeAudit from './SecurityFeeAudit';
import SecurityFeeDashboard from './SecurityFeeDashboard';

const MONTHS = [
  { value: 1, label: 'January' }, { value: 2, label: 'February' }, { value: 3, label: 'March' },
  { value: 4, label: 'April' }, { value: 5, label: 'May' }, { value: 6, label: 'June' },
  { value: 7, label: 'July' }, { value: 8, label: 'August' }, { value: 9, label: 'September' },
  { value: 10, label: 'October' }, { value: 11, label: 'November' }, { value: 12, label: 'December' }
];

const currentDate = new Date();
const currentMonth = currentDate.getMonth() + 1;
const currentYear = currentDate.getFullYear();
const YEAR_OPTIONS = Array.from({ length: 5 }, (_, i) => currentYear - i);

const DashboardSecurityFee = () => {
  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [appliedMonth, setAppliedMonth] = useState(currentMonth);
  const [appliedYear, setAppliedYear] = useState(currentYear);
  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSearch = () => {
    setAppliedMonth(month);
    setAppliedYear(year);
    setSearchTrigger((t) => t + 1);
  };

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Security Fee Dashboard</h1>
            <p className="text-gray-600 mt-2">Monitor security fee collections and compliance across all operators</p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <div className="flex items-center gap-2">
              <Calendar className="h-4 w-4 text-gray-500" />
              <select
                value={month}
                onChange={(e) => setMonth(Number(e.target.value))}
                className="border border-gray-300 rounded-md px-3 py-2 bg-white text-sm"
              >
                {MONTHS.map((m) => (
                  <option key={m.value} value={m.value}>{m.label}</option>
                ))}
              </select>
              <select
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
                className="border border-gray-300 rounded-md px-3 py-2 bg-white text-sm"
              >
                {YEAR_OPTIONS.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
            <button
              type="button"
              onClick={handleSearch}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium"
            >
              <Search className="h-4 w-4" />
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Security Fee Dashboard - Main component */}
      <div className="mb-8">
        <SecurityFeeDashboard appliedMonth={appliedMonth} appliedYear={appliedYear} />
      </div>

      {/* Fee Collection Charts */}
      <div className="mb-8">
        <FeeCollectionCharts appliedMonth={appliedMonth} appliedYear={appliedYear} searchTrigger={searchTrigger} />
      </div>

      {/* Security Fee Audit */}
      <div className="mb-8">
        <SecurityFeeAudit appliedMonth={appliedMonth} appliedYear={appliedYear} searchTrigger={searchTrigger} />
      </div>
    </main>
  );
};

export default DashboardSecurityFee;